export const RENDER_TIME_OUT = 2000;
export const DEFAULT_PLAYER_IMAGE = 'https://icebergmedia.blob.core.windows.net/photos/players/default.player.png';
